import { fetchAccount as upstreamFetchAccount } from 'customer-flows/gql/queries/account'

export default function account({ stores, callerContext }: CommandArgs) {
  const accountStore = stores['account']

  async function fetchAccount() {
    accountStore.account.promise = upstreamFetchAccount(callerContext).then((response) => {
      return response.data.account
    })

    await accountStore.account.promise
  }

  return { fetchAccount }
}

declare global {
  export type AccountCommands = ReturnType<typeof account>

  // Add to global scope
  interface CommandRegistry {
    account: AccountCommands
  }
}
